<template>
  <div class="pg-query-tag" v-if="list.length > 0">
    <div v-for="item in list" :key="item.property">
      <div v-if="item.value" class="pg-query-tag__item">
        <span class="pg-query-tag__item-title">{{ item.label }}</span>
        <Tag closable @close="close(item.property)">{{ item.value }}</Tag>
      </div>
    </div>
  </div>
</template>
<script setup>
import { getValueByPathNotNull } from '../../../utils/index'
import { computed } from 'vue'
import { Tag } from 'element-ui'
const props = defineProps({
  queryForm: Object,
  queryData: Object,
})
const getoptionsValue = (val, options) => {
  if (!options) {
    return val
  } else {
    for (const option of options) {
      const optionCode = option.code ?? option.value
      const code = typeof optionCode === 'string' ? `${val}` : val
      if (code === optionCode) {
        return option.name ?? option.label
      }
    }
    return val
  }
}
const getValue = (val, options) => {
  if (typeof val === 'object') {
    return val.name ?? val.label
  } else {
    return getoptionsValue(val, options)
  }
}
const list = computed(() => {
  if (!props.queryData || !props.queryForm?.items?.length) {
    return []
  }
  return props.queryForm.items.reduce((acc, item) => {
    const value = getValueByPathNotNull(props.queryData, item.property, 'NULL')
    if (!item.visible || value === 'NULL') {
      return acc
    } else if (Array.isArray(value)) {
      const resValue = value.map((val) =>
        getValue(val, item.parameter?.options ?? item.parameter?.source)
      )
      acc.push({
        property: item.property,
        label: item.label,
        value: resValue.join(
          ['panguDatePicker', 'PgDatePicker'].indexOf(item.component?.code) === '-1' ? ',' : '~'
        ),
      })
    } else {
      acc.push({
        property: item.property,
        label: item.label,
        value: getValue(value, item.parameter?.options ?? item.parameter?.source),
      })
    }
    return acc
  }, [])
})

const emit = defineEmits('close')
const close = (property) => {
  emit('close', property)
}
</script>
<style lang="scss">
@import '../style/query-tag.scss';
</style>
